import {
  AfterViewInit,
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ApiService } from '../../../Services/api.service';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { ContentLinkedComponent } from '../content-linked/content-linked.component';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { RichTextFieldComponent } from '../../../Common/Components/rich-text-field/rich-text-field.component';
import { Toolbar } from 'ngx-editor';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'app-content-page-form',
  standalone: true,
  imports: [
    NzIconModule,
    NzButtonModule,
    NzSelectModule,
    DragDropModule,
    NzFormModule,
    NzDrawerModule,
    ContentLinkedComponent,
    NzInputModule,
    NzDatePickerModule,
    NzTagModule,
    NzCollapseModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NzSwitchModule,
    RichTextFieldComponent,
  ],
  templateUrl: './content-page-form.component.html',
  styleUrl: './content-page-form.component.scss',
})
export class ContentPageFormComponent implements AfterViewInit {
  pageType: any = '';
  contentId: any = '';
  editPage: boolean = false;
  linkDrawer: boolean = false;
  viewSecret:boolean = false;
  addEditContentForm: FormGroup = new FormGroup({});
  descArrayForm: FormGroup = new FormGroup({});
  contentData: any = [];
  contentName: any = 'New Content';
  inValidAddEditContentForm: boolean = false;
  actionValue: string = '';
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['ordered_list', 'bullet_list'],
    ['link', 'image'],
  ];

  minimumOptionsToolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
  ];
  defaultPageType: any = '';
  @ViewChildren('panelRef', { read: ElementRef })
  panelElements!: QueryList<ElementRef>;
  contentPageFields: any = [
    {
      id: 1,
      fieldType: 'input',
      fieldName: 'Content Name',
      required: true,
      placeholder: 'Enter Content Name',
      formControlName: 'content',
      pageTypes: ['CO', 'FA', 'N', 'C1', 'S', 'W', 'O', 'ON','BI','NL'],
      maxLength: 50,
    },
    {
      id: 2,
      fieldType: 'input',
      fieldName: 'Menu Title',
      required: true,
      placeholder: 'Enter Menu Title',
      formControlName: 'menuTitle',
      pageTypes: ['C1', 'BI', 'NL'],
      maxLength: 50,
    },
    {
      id: 3,
      fieldType: 'input',
      fieldName: 'Product Label for Website',
      required: true,
      placeholder: 'Products',
      formControlName: 'productLabelForWebsite',
      pageTypes: ['W'],
      maxLength: 128,
    },
    {
      id: 4,
      fieldType: 'textarea',
      fieldName: 'Allowance Description',
      required: true,
      placeholder: 'Enter Allowance Description',
      formControlName: 'allowanceDescription',
      pageTypes: ['O'],
    },
    {
      id: 5,
      fieldType: 'textarea',
      fieldName: 'Allotment Description',
      required: true,
      placeholder: 'Enter Allotment Description',
      formControlName: 'allotmentDescription',
      pageTypes: ['O'],
    },
    {
      id: 6,
      fieldType: 'textarea',
      fieldName: 'Title',
      required: false,
      placeholder: 'Enter Title',
      formControlName: 'title',
      pageTypes: ['CO'],
      maxLength: 128,
    },
    {
      id: 7,
      fieldType: 'textarea',
      fieldName: 'Description',
      required: true,
      placeholder: 'Enter Description',
      formControlName: 'description',
      pageTypes: ['CO'],
      richTextEditor: true,
    },
    {
      id: 8,
      fieldType: 'textarea',
      fieldName: 'Top Banner',
      required: false,
      placeholder: 'Enter Value',
      formControlName: 'topBanner',
      pageTypes: ['W'],
    },
    {
      id: 9,
      fieldType: 'textarea',
      fieldName: 'Bottom Banner',
      required: false,
      placeholder: 'Enter Value',
      formControlName: 'bottomBanner',
      pageTypes: ['W'],
    },
    {
      id: 10,
      questionNbr: 1,
      fieldType: 'accordion',
      collapse: true,
      groupHeader: 'Group',
      required: true,
      placeholder: 'Enter a description',
      pageTypes: ['FA', 'N', 'S', 'C1'],
      fields: [
        {
          fieldName: 'Question',
          fieldType: 'input',
          placeholder: 'Enter Question',
          formControlName: 'title',
          maxLength: 128,
        },
        {
          fieldName: 'Answer',
          fieldType: 'textarea',
          placeholder: 'Enter Answer',
          formControlName: 'description',
        },
      ],
    },
    {
      id: 11,
      fieldType: 'textarea',
      fieldName: 'Description',
      required: true,
      placeholder: 'Enter Description',
      formControlName: 'description',
      pageTypes: ['ON'],
    },
    {
      id: 12,
      fieldType: 'input',
      fieldName: 'Tenant Id',
      required: true,
      placeholder: 'Enter Tenant Id',
      formControlName: 'tenantId',
      pageTypes: ['BI'],
      maxLength: 250,
    },
    {
      id: 13,
      fieldType: 'input',
      fieldName: 'Client Id',
      required: true,
      placeholder: 'Enter Client Id',
      formControlName: 'clientId',
      pageTypes: ['BI'],
      maxLength: 250,
    },
    {
      id: 14,
      fieldType: 'input',
      fieldName: 'Workspace Id',
      required: true,
      placeholder: 'Enter Workspace Id',
      formControlName: 'workspaceId',
      pageTypes: ['BI'],
      maxLength: 250,
    },
      {
      id: 15,
      fieldType: 'input',
      fieldName: 'Client Secret',
      required: true,
      placeholder: 'Enter Client Secret',
      formControlName: 'clientSecret',
      pageTypes: ['BI'],
      maxLength: 250,
    },
    {
      id: 16,
      fieldType: 'textarea',
      fieldName: 'URL',
      required: true,
      placeholder: 'Enter URL',
      formControlName: 'url',
      pageTypes: ['NL'],
      maxLength: 500,
    },
      {
      id: 17,
      fieldType: 'inputblock',
      fieldName: 'Email',
      sectionTitle: 'Display to specific employees only.',
      sectionDescription:
        "Enter the email address used on the employee's record to display the navigation link. If no email addresses are entered the link will be visible for all employees.",
      required: false,
      placeholder: 'Enter Email',
      formControlName: 'email',
      pageTypes: ['NL'],
      maxLength: 500,
    },
  ];
  biFieldMap: { title: string; control: string }[] = [
    { title: 'tenant-id', control: 'tenantId' },
    { title: 'client-id', control: 'clientId' },
    { title: 'client-secret', control: 'clientSecret' },
    { title: 'workspace-id', control: 'workspaceId' },
  ];
  nlFieldMap: { title: string; control: string }[] = [
    { title: 'url', control: 'url' },
    { title: 'email', control: 'email' },
  ];
  emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  emailError: boolean = false;
  emailEmpty: boolean = false;
  emailDuplicate: boolean = false;
  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.initAddForm();

    let routePageType = this.route.snapshot.paramMap.get('pageType');
    this.contentId = this.route.snapshot.paramMap.get('id');

    const validPageTypes = [
      'CO',
      'FA',
      'N',
      'C1',
      'S',
      'W',
      'O',
      'ON',
      'BI',
      'NL',
    ];
    this.pageType = validPageTypes.includes(routePageType || '')
      ? routePageType
      : 'S';
    this.defaultPageType = validPageTypes.includes(routePageType || '')
      ? ''
      : routePageType;
    this.apiService.contentPageType = this.pageType;

    const accordionField = this.contentPageFields.find(
      (field: any) => field.fieldType === 'accordion' && field.id === 10,
    );

    if (accordionField && accordionField.fields) {
      if (
        this.pageType === 'C1' ||
        this.pageType === 'N' ||
        this.pageType === 'S'
      ) {
        accordionField.fields[0].fieldName = 'Title';
        accordionField.fields[0].placeholder = 'Enter Title';
        accordionField.fields[1].fieldName = 'Description';
        accordionField.fields[1].placeholder = 'Enter Description';
      } else {
        accordionField.fields[0].fieldName = 'Question';
        accordionField.fields[0].placeholder = 'Enter Question';
        accordionField.fields[1].fieldName = 'Answer';
        accordionField.fields[1].placeholder = 'Enter Answer';
      }
    }

    if (this.contentId) {
      this.initEditForm();
    }
  }

  ngAfterViewInit(): void {
    this.panelElements.changes.subscribe((node) => {
      if (this.actionValue) this.focusPanel();
    });
  }

  initEditForm() {
    this.editPage = true;
    this.addEditContentForm.get('content')?.disable();
    this.getContentData();
  }

  initAddForm() {
    this.addEditContentForm = this.fb.group({
      content: ['', Validators.required],
      title: [''],
      description: ['', Validators.required],
      menuTitle: ['', Validators.required],
      productLabelForWebsite: ['Product'],
      topBanner: [''],
      bottomBanner: [''],
      allowanceDescription: [''],
      allotmentDescription: [''],
      clientSecret: ['', Validators.required],
      clientId: ['', Validators.required],
      workspaceId: ['', Validators.required],
      tenantId: ['', Validators.required],
      url: ['', Validators.required],
      email: [''],
      emailArray: this.fb.array([]),
      descArray: this.fb.array([]),
    });
    this.addItemtoDescArray();
  }

  getContentData() {
    this.apiService.getContentById(this.contentId).subscribe((response) => {
      this.contentData = response[0];
      this.setContentName(this.contentData?.contentShortDesc);
      this.loadContentForm();
    });
  }

  loadContentForm() {
    this.addEditContentForm.patchValue({
      content: this.contentData?.contentShortDesc,
      menuTitle: this.contentData?.menuTitle,
    });

    let titleGroup: any = [];
    this.descArray.clear();
    this.emailArray.clear();
    this.contentData?.contentDesc.forEach((desc: any, index: number) => {
      if (this.pageType == 'CO') {
        this.addEditContentForm.patchValue({
          title: this.contentData?.contentTitle[index],
          description: desc,
        });
      } else if (this.pageType == 'ON') {
        this.addEditContentForm.patchValue({
          description: desc,
        });
      } else if (this.pageType == 'W') {
        if (index == 0) {
          this.addEditContentForm.patchValue({
            productLabelForWebsite: desc,
          });
        } else if (index == 1) {
          this.addEditContentForm.patchValue({
            topBanner: desc,
          });
        } else if (index == 2) {
          this.addEditContentForm.patchValue({
            bottomBanner: desc,
          });
        }
      } else if (this.pageType == 'O') {
        if (index == 0) {
          this.addEditContentForm.patchValue({
            allowanceDescription: desc,
          });
        } else if (index == 1) {
          this.addEditContentForm.patchValue({
            allotmentDescription: desc,
          });
        }
      } else if (this.pageType == 'BI') {
        const controlName = this.biFieldMap.find(
          (f) => f.title === this.contentData?.contentTitle[index],
        )?.control;
        if (controlName) {
          this.addEditContentForm.patchValue({ [controlName]: desc });
        }
      } else if (this.pageType == 'NL') {
        const controlName = this.nlFieldMap.find(
          (f) => f.title === this.contentData?.contentTitle[index],
        )?.control;
        if (controlName === 'email') {
          const emails: string[] = Array.isArray(desc)
            ? desc
            : desc
              ? desc.split(',').map((e: string) => e.trim()).filter(Boolean)
              : [];
          emails.forEach((e: string) => this.emailArray.push(new FormControl(e)));
        } else if (controlName) {
          this.addEditContentForm.patchValue({ [controlName]: desc });
        }
      } else {
        titleGroup.push({
          title: this.contentData?.contentTitle[index],
          description: desc,
        });
        this.addItemtoDescArray();
      }
    });
    if (titleGroup.length > 0) {
      this.descArray.patchValue(titleGroup);
    }
  }

  setContentName(contentName: any) {
    this.contentName = 'Edit - ' + contentName;
  }

  get descArray() {
    return this.addEditContentForm.controls['descArray'] as FormArray;
  }

  get emailArray(): FormArray {
    return this.addEditContentForm.controls['emailArray'] as FormArray;
  }

  addEmail() {
    const value = this.addEditContentForm.controls['email'].value?.trim();
    if (!value) {
      this.emailEmpty = true;
      this.emailError = false;
      this.emailDuplicate = false;
      return;
    }
    if (!this.emailPattern.test(value)) {
      this.emailError = true;
      this.emailEmpty = false;
      this.emailDuplicate = false;
      return;
    }
    const isDuplicate = this.emailArray.value.some(
      (e: string) => e.toLowerCase() === value.toLowerCase(),
    );
    if (isDuplicate) {
      this.emailDuplicate = true;
      this.emailError = false;
      this.emailEmpty = false;
      return;
    }
    this.emailArray.push(new FormControl(value));
    this.addEditContentForm.controls['email'].setValue('');
    this.emailError = false;
    this.emailEmpty = false;
    this.emailDuplicate = false;
  }

  clearEmailErrors() {
    this.emailError = false;
    this.emailEmpty = false;
    this.emailDuplicate = false;
  }

  removeEmail(index: number): void {
    if (index >= 0 && index < this.emailArray.length) {
      this.emailArray.removeAt(index);
    }
  }

  addItemtoDescArray(action?: string) {
    this.descArrayForm = this.fb.group({
      title: [''],
      description: ['', Validators.required],
      collapse: [false],
    });
    this.descArray.push(this.descArrayForm);
    this.actionValue = action ? action : '';
  }

  focusPanel() {
    this.panelElements.last.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    this.actionValue = '';
  }

  deleteDescArrayItem(descArrayIndex: number) {
    this.descArray.removeAt(descArrayIndex);
  }

  get descArrayArrayControls() {
    return (this.addEditContentForm.controls['descArray'] as FormArray)
      .controls as FormGroup[];
  }

  getIndexNumber(index: any) {
    return index + 1;
  }
  addContentData() {
    if (!this.validateForm()) {
      let titleArray: any = [];
      let descArray: any = [];
      if (this.pageType == 'CO') {
        titleArray.push(this.addEditContentForm.controls.title.value);
        descArray.push(this.addEditContentForm.controls.description.value);
      } else if (this.pageType == 'ON') {
        descArray.push(this.addEditContentForm.controls.description.value);
      } else if (this.pageType == 'W') {
        titleArray = ['', '', ''];
        descArray = [
          this.addEditContentForm.controls.productLabelForWebsite.value,
          this.addEditContentForm.controls.topBanner.value,
          this.addEditContentForm.controls.bottomBanner.value,
        ];
      } else if (this.pageType == 'O') {
        titleArray = ['', ''];
        descArray = [
          this.addEditContentForm.controls.allowanceDescription.value,
          this.addEditContentForm.controls.allotmentDescription.value,
        ];
      } else if (this.pageType == 'BI') {
        this.biFieldMap.forEach((f) => {
          titleArray.push(f.title);
          descArray.push(this.addEditContentForm.controls[f.control].value);
        });
      } 
      else if (this.pageType == 'NL') {
        this.nlFieldMap.forEach((f) => {
          titleArray.push(f.title);
          descArray.push(
            f.control === 'email'
              ? this.emailArray.value.join(',')
              : this.addEditContentForm.controls[f.control].value,
          );
        });
      }else {
        this.addEditContentForm.controls.descArray.value.forEach(
          (control: any, index: any) => {
            titleArray.push(control.title);
            descArray.push(control.description);
          },
        );
      }

      let data = {
        contentShortDesc: this.addEditContentForm.controls.content.value,
        pageType: this.defaultPageType ? this.defaultPageType : this.pageType,
        menuTitle: this.addEditContentForm.controls.menuTitle.value,
        contentTitle: titleArray,
        contentDesc: descArray,
      };
      let postUrl = this.editPage
        ? this.apiService.updateContent(this.contentId, data)
        : this.apiService.addContent(data);
      postUrl.subscribe(
        (res) => {
          if (res.SeqNo || res.seqNo) {
            this.apiService.createNotification('success', res.message);
            this.contentId = res.seqNo;
            this.editPage = true;
            this.setContentName(data.contentShortDesc);
          }
        },
        (err) => {
          this.apiService.createNotification('error', err?.error?.message);
        },
      );
    } else {
      this.inValidAddEditContentForm = true;
    }
  }

  collapseAll() {
    this.contentPageFields.map((node: any) => {
      if (
        node.pageTypes.includes(this.apiService.contentPageType) &&
        node.fieldType == 'accordion'
      ) {
        node.collapse = !node.collapse;
      }
    });
  }

  drop(event: CdkDragDrop<any[]>, questionArray: any) {
    moveItemInArray(questionArray, event.previousIndex, event.currentIndex);
    this.descArray.patchValue(questionArray);
  }

  onChildDrop(event: CdkDragDrop<any[]>, questionArray: any) {
    this.drop(event, questionArray); // reuse logic
  }

  validateForm() {
    if (this.pageType == 'CO') {
      return this.addEditContentForm.controls.content.value &&
        this.addEditContentForm.controls.description.value
        ? false
        : true;
    } else if (this.pageType == 'C1') {
      return this.addEditContentForm.controls.content.value &&
        this.addEditContentForm.controls['descArray'].valid &&
        this.addEditContentForm.controls.menuTitle.value
        ? false
        : true;
    } else if (
      this.pageType == 'FA' ||
      this.pageType == 'N' ||
      this.pageType == 'S'
    ) {
      return this.addEditContentForm.controls.content.value &&
        this.addEditContentForm.controls['descArray'].valid
        ? false
        : true;
    } else if (this.pageType == 'ON') {
      return this.addEditContentForm.controls.content.value &&
        this.addEditContentForm.controls.description.value
        ? false
        : true;
    } else if (this.pageType == 'O') {
      return this.addEditContentForm.controls.content.value &&
        this.addEditContentForm.controls.allotmentDescription.value &&
        this.addEditContentForm.controls.allowanceDescription.value
        ? false
        : true;
    } else if (this.pageType == 'W') {
      return this.addEditContentForm.controls.content.value &&
        this.addEditContentForm.controls.productLabelForWebsite.value
        ? false
        : true;
    } else if (this.pageType == 'BI') {
      return this.addEditContentForm.controls.content.value &&
        this.addEditContentForm.controls.tenantId.value &&
        this.addEditContentForm.controls.clientId.value &&
        this.addEditContentForm.controls.clientSecret.value &&
        this.addEditContentForm.controls.workspaceId.value &&
        this.addEditContentForm.controls.menuTitle.value
        ? false
        : true;
    } else if (this.pageType == 'NL') {
      return this.addEditContentForm.controls.content.value &&
        this.addEditContentForm.controls.url.value &&
        this.addEditContentForm.controls.menuTitle.value
        ? false
        : true;
    } else {
      return false;
    }
  }

  handleCollapse(i: number) {
    let descArray = this.addEditContentForm.controls['descArray']?.value;
    descArray[i].collapse = !descArray.collapse;
    this.addEditContentForm.get('descArray')?.setValue(descArray);
  }

  ngOnDestroy() {
    if (this.defaultPageType) {
      this.apiService.contentPageType = this.defaultPageType;
    }
  }

  onPaste(event: ClipboardEvent): void {
  const clipboardData = event.clipboardData;
  
  if (clipboardData && clipboardData.items) {
    const items = Array.from(clipboardData.items);
    
    // Check if any item in the clipboard is an image
    const hasImage = items.some(item => item.type.indexOf('image') !== -1);

    if (hasImage) {
      // Prevent the paste action entirely
      event.preventDefault();
    }
  }
}
}
